/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

const pad = (n: number): string => String(n).padStart(2, '0');

const isoDay = (d: Date): string =>
  `${String(d.getFullYear()).padStart(4, '0')}-${pad(d.getMonth() + 1)}-${pad(
    d.getDate(),
  )}`;

/**
 * Periodo predefinito della dashboard: dal primo giorno del mese di due mesi
 * fa fino a oggi (sempre entro i 366 giorni che l'API accetta).
 */
export const defaultPeriod = (
  today: Date = new Date(),
): {fromDate: string; toDate: string} => ({
  fromDate: isoDay(new Date(today.getFullYear(), today.getMonth() - 2, 1)),
  toDate: isoDay(today),
});

/** Larghezza della barra in percentuale (0-100) rispetto al valore massimo. */
export const barWidth = (value: number, max: number): number => {
  if (!Number.isFinite(value) || !Number.isFinite(max) || max <= 0) return 0;
  if (value <= 0) return 0;
  return Math.min(100, Math.round((value / max) * 1000) / 10);
};

/** Importo "12.34" dell'API come numero; 0 se mancante o non valido. */
export const amountOf = (value: string | number | null | undefined): number => {
  if (value === null || value === undefined) return 0;
  const n = typeof value === 'number' ? value : Number(String(value).trim());
  return Number.isFinite(n) ? n : 0;
};

/** Mese "2026-03" dell'API come "03/2026"; il testo originale se non è un mese. */
export const monthLabel = (month: string): string => {
  const m = /^(\d{4})-(\d{2})$/.exec(month);
  return m ? `${m[2]}/${m[1]}` : month;
};
